import VerticalNav from './VerticalNav'

export default VerticalNav
